export default __webpack_public_path__ + "static/media/filter-dsb.d9c20657.png";